import React from 'react';
import { Field } from 'redux-form';
import { isEmpty } from 'lodash';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import WorkdayInput from './workdayInput';

const ScheduleRowField = ({ day, dayConflicts, disabled, times }) => {
  const dayHasConflicts = !isEmpty(dayConflicts);

  return (
    <div className="c-schedule-row-field u-mb-" data-automation-id={day}>
      <div
        className={classNames('o-flexbox c-schedule-row-field__inputs', { 'warning-border': dayHasConflicts })}
        key={day}
      >
        <Field
          name={`${day}.weekDay`}
          enabledName={`${day}.enabled`}
          component={WorkdayInput}
          dayConflicts={dayConflicts}
          dayHasConflicts={dayHasConflicts}
          disabled={disabled}
        />
        <div className="o-flexbox__item">
          <Field
            name={`${day}.startTime`}
            component="select"
            className="c-select c-select--small u-mr--"
            disabled={disabled}
            data-automation-id={`${day}-start-time`}
          >
            {times}
          </Field>
          <Field
            name={`${day}.endTime`}
            component="select"
            className="c-select c-select--small"
            disabled={disabled}
            data-automation-id={`${day}-end-time`}
          >
            {times}
          </Field>
        </div>
      </div>
    </div>
  );
};

ScheduleRowField.propTypes = {
  day: PropTypes.string.isRequired,
  dayConflicts: PropTypes.arrayOf(PropTypes.shape({})),
  disabled: PropTypes.bool,
  times: PropTypes.array.isRequired,
};

ScheduleRowField.defaultProps = {
  dayConflicts: [],
  disabled: false,
};

export default ScheduleRowField;
